import { render, staticRenderFns } from "./ModalStack.vue?vue&type=template&id=dfbce01a&scoped=true&"
import script from "./ModalStack.vue?vue&type=script&lang=ts&"
export * from "./ModalStack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbce01a",
  null
  
)

export default component.exports